
import { Component, Vue } from 'vue-property-decorator'

/**
 * 画像の基底コンポーネント
 */
@Component
export default class ImageBase extends Vue {}
